/**
 * Homepage SEO review: section decisions and compact specialty previews.
 * Aligns with docs/HOMEPAGE-SEO-REVIEW.md — do not duplicate landing-page FAQs here.
 */

import {
  HOME_EDUCATION_PREVIEW,
  HOME_ERP_PREVIEW,
  HOME_MARKETPLACE_PREVIEW,
} from './homeSpecialtySections';

/**
 * Compact homepage cards linking to full SEO landing pages.
 * Third-party chips sourced from delivery audits: ACAP, SAE, CSU, Navitasci, WLA (wlaplux).
 */
export const HOME_SPECIALTY_COMPACT = [
  {
    id: 'education',
    eyebrow: HOME_EDUCATION_PREVIEW.eyebrow,
    title: 'Education websites',
    summary:
      'WordPress multisite and Roots Sage builds with course discovery, campaign pages, flexible CMS sections, forms, search, chat widgets, analytics, and hosted delivery.',
    bullets: ['Course CMS', 'Campaigns', 'Forms & search'],
    integrations: [
      'Sage / ACF',
      'WP Engine',
      'Course pages',
      'Campaign CMS',
    ],
    to: '/education-website-development',
    cta: 'Education platforms',
    tone: 'mid',
  },
  {
    id: 'forms-crm',
    eyebrow: 'Lead capture integrations',
    title: 'Forms and CRM integration',
    summary:
      'Multi-provider lead flows with FormAssembly, Marketo, WPForms, Calendly, HubSpot, Salesforce, custom embeds, and thank-you tracking.',
    bullets: ['FormAssembly', 'Marketo', 'CRM sync'],
    integrations: ['WPForms', 'Calendly', 'HubSpot', 'Salesforce'],
    to: '/form-crm-integrations',
    cta: 'Forms & CRM',
    tone: 'dark',
  },
  {
    id: 'education-search',
    eyebrow: 'Course discovery',
    title: 'Education search platforms',
    summary:
      'Course, campus, event, and content discovery using Algolia, SiteSearch360, faceted filters, autocomplete, and custom index rules.',
    bullets: ['Course search', 'Filters', 'Autocomplete'],
    integrations: [
      'Algolia',
      'SiteSearch360',
      'Fuse.js',
      'Search indexes',
    ],
    to: '/education-search-platforms',
    cta: 'Search platforms',
    tone: 'light',
  },
  {
    id: 'woocommerce-payments',
    eyebrow: HOME_ERP_PREVIEW.eyebrow,
    title: 'WooCommerce payments and CRM',
    summary:
      'WooCommerce operations with custom checkout, Flywire payments, invoice gateways, HubSpot/Salesforce sync, bundles, discounts, and PDF invoices.',
    bullets: ['Checkout UX', 'Payments', 'CRM sync'],
    integrations: [
      'WooCommerce',
      'Flywire',
      'HubSpot',
      'Salesforce',
    ],
    to: '/woocommerce-payment-crm-integrations',
    cta: 'Payment & CRM stack',
    tone: 'dark',
  },
  {
    id: 'analytics-tags',
    eyebrow: 'Growth measurement',
    title: 'Analytics and tag management',
    summary:
      'Marketing measurement layers with GTM, dataLayer events, Hotjar, Microsoft Clarity, Seeka, LOCALiQ, Poptin, Crazy Egg, and snippet governance.',
    bullets: ['GTM', 'Heatmaps', 'Conversion events'],
    integrations: ['Hotjar', 'Clarity', 'Seeka', 'Crazy Egg'],
    to: '/analytics-tag-management',
    cta: 'Analytics setup',
    tone: 'mid',
  },
  {
    id: 'privacy-widgets',
    eyebrow: 'Compliance and trust',
    title: 'Privacy, translation and widgets',
    summary:
      'Specialized widgets for OneTrust privacy notices, GTranslate, Trustpilot, Discover Uni, chat, media feeds, maps, and third-party embeds.',
    bullets: ['Consent', 'Translation', 'Trust widgets'],
    integrations: ['OneTrust', 'GTranslate', 'Trustpilot', 'Unibuddy'],
    to: '/privacy-translation-widgets',
    cta: 'Trust integrations',
    tone: 'light',
  },
  {
    id: 'cataloging',
    eyebrow: HOME_MARKETPLACE_PREVIEW.eyebrow,
    title: 'Marketplace cataloging',
    summary:
      'Product data, template mapping, SEO listings, structured schema, search indexes, and bulk upload support for major marketplaces.',
    bullets: ['Listing SEO', 'Bulk uploads', 'Channel templates'],
    integrations: ['Yoast SEO', 'Schema Pro', 'Algolia index', 'Tinify media'],
    to: '/marketplace-cataloging',
    cta: 'Cataloging services',
    tone: 'light',
  },
];

export const HOMEPAGE_SECTION_DECISIONS = [
  { section: 'Hero carousel', decision: 'keep-update' },
  { section: 'Agency value proposition', decision: 'keep-update' },
  { section: 'Core services grid', decision: 'keep' },
  { section: 'Quick service links', decision: 'keep' },
  { section: 'Portfolio', decision: 'keep-move-higher' },
  { section: 'Specialty previews', decision: 'compact-preview' },
  { section: 'Industries', decision: 'keep-move-lower' },
  { section: 'Process', decision: 'keep' },
  { section: 'Counters', decision: 'remove' },
  { section: 'Testimonials', decision: 'keep' },
  { section: 'Blog', decision: 'keep-move-lower' },
  { section: 'Brands', decision: 'keep' },
  { section: 'Problems we solve', decision: 'keep-bottom' },
  { section: 'Final CTA', decision: 'keep' },
];
